<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import { maskSlug } from "@/common/utils/mask";

import type { NameType, NamePayloadType } from "@/common/types/name";

import { baseInput, baseSelect } from "@/common/components";

const { t } = useI18n();

const emit = defineEmits(["update:data", "salve:data"]);

const props = defineProps<{
  data?: NameType | null;
  isPatch?: boolean;
}>();

const DEFAULT_DATA = {
  name: "",
};

const payload = ref<NamePayloadType>({ ...DEFAULT_DATA });

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { name } = props.data;

  payload.value = {
    ...payload.value,
    name,
  };
}

const debouceUpdate = debounce(update, 300);

watchEffect(() => {
  resumeData();
});
</script>

<template>
  <section class="form-slug">
    <base-input
      v-model="payload.name"
      :value="payload.name"
      :placeholder="t('common.placeholders.name')"
      required
      @update:modelValue="debouceUpdate('name')"
    >
      <template #label> {{ t("common.labels.name") }} * </template>
    </base-input>
  </section>
</template>

<style lang="scss" scoped>
.form-slug {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
}
</style>
